const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const OfficeModal = require("./modals/OfficeModal");
const {PORTAL_CONTAINERS} = require("../../shared/PortalConstants");

const styles = require("./styles/InfoIcon.css");

module.exports = createReactClass({
	displayName: "InfoIcon",

	propTypes: {
		text: PT.oneOfType([PT.string, PT.element]).isRequired,
		title: PT.string,
		className: PT.string,
		textClass: PT.string, // Sets position of info text
		isModal: PT.bool,
		modalClass: PT.string,
		modalTextClass: PT.string,
		// Instead of ? icon, it's this instead
		iconAsElement: PT.oneOfType([PT.string, PT.element]),
		color: PT.string,
	},

	getInitialState: function() {
		return {
			isModalOpen: false,
		};
	},

	openModal: function() {
		this.setState({isModalOpen: true});
	},

	closeModal: function() {
		this.setState({isModalOpen: false});
	},

	render: function() {
		const {
			text,
			title,
			textClass,
			className,
			isModal,
			modalClass,
			modalTextClass,
			iconAsElement,
			color,
		} = this.props;
		const qSvg = (
			<svg
				version="1.1"
				x="0px"
				y="0px"
				viewBox="0 0 40 40"
				width="40"
				height="40"
				preserveAspectRatio="none"
				className={styles.qSvg}
			>
				<g>
					<circle className={styles.qCircle} cx="20" cy="20" r="20" />
					<path
						className={styles.qq}
						d="M17.40483,24.98063a15.42018,15.42018,0,0,1,.13107-2.12332,7.37827,7.37827,0,0,1,.44564-1.72138,6.308,6.308,0,0,1,.82136-1.45923,9.86083,9.86083,0,0,1,1.25827-1.35439q.59418-.52427,1.101-1.02233a8.357,8.357,0,0,0,.87379-.99613,4.17985,4.17985,0,0,0,.568-1.04855,3.41327,3.41327,0,0,0,.201-1.17963,3.13711,3.13711,0,0,0-.6903-2.21943,2.66292,2.66292,0,0,0-2.03594-.734,3.42844,3.42844,0,0,0-1.05729.166,2.46753,2.46753,0,0,0-.91748.533,2.67921,2.67921,0,0,0-.64661.935,3.61617,3.61617,0,0,0-.26214,1.35439h-5.068a7.56157,7.56157,0,0,1,.64661-3.17188,6.25061,6.25061,0,0,1,1.69516-2.2107A7.088,7.088,0,0,1,16.97667,7.4261a10.84889,10.84889,0,0,1,3.102-.42816,10.97848,10.97848,0,0,1,3.28547.45437,6.75737,6.75737,0,0,1,2.44662,1.31943,5.68391,5.68391,0,0,1,1.52914,2.14954,7.58015,7.58015,0,0,1,.533,2.92721,5.85451,5.85451,0,0,1-.34952,2.07963,7.47274,7.47274,0,0,1-.9437,1.74759,12.66843,12.66843,0,0,1-1.36312,1.58156q-.76893.76022-1.62526,1.54662a6.00759,6.00759,0,0,0-.81262.90875,4.62391,4.62391,0,0,0-.52428.95243,4.47889,4.47889,0,0,0-.27961,1.066,11.25383,11.25383,0,0,0-.09612,1.24953Zm-.5068,5.3651a2.779,2.779,0,0,1,.201-1.066,2.49428,2.49428,0,0,1,.568-.84758,2.68653,2.68653,0,0,1,.89127-.568,3.37359,3.37359,0,0,1,2.34177,0,2.68653,2.68653,0,0,1,.89127.568,2.49425,2.49425,0,0,1,.568.84758,2.77883,2.77883,0,0,1,.201,1.066,2.73264,2.73264,0,0,1-.201,1.04855,2.49435,2.49435,0,0,1-.568.84758,2.5786,2.5786,0,0,1-.89127.55923,3.51137,3.51137,0,0,1-2.34177,0,2.5786,2.5786,0,0,1-.89127-.55923,2.49437,2.49437,0,0,1-.568-.84758A2.73282,2.73282,0,0,1,16.898,30.34573Z"
					/>
				</g>
			</svg>
		);
		let mainClass = isModal ? styles.iconModal : styles.icon;
		if (color) mainClass += " " + styles[color];
		if (className) mainClass += " " + className;
		if (iconAsElement) mainClass = className;
		let mClass = styles.modal;
		if (modalClass) mClass += " " + modalClass;
		let mTextClass = styles.modalText;
		if (modalTextClass) mTextClass += " " + modalTextClass;

		if (isModal) {
			let modal;
			let clickAction = this.openModal;
			if (this.state.isModalOpen) {
				modal = (
					<OfficeModal
						onClose={this.closeModal}
						level="warning"
						portalContainer={PORTAL_CONTAINERS.INFO_MODAL}
						closeOnEsc={true}
						modalClass={mClass}
						backdropClass={styles.backdrop}
					>
						<div className={styles.title}>{title}</div>
						<div className={mTextClass}>{text}</div>
					</OfficeModal>
				);
				clickAction = null;
			}
			let qIcon = qSvg;
			if (iconAsElement) {
				qIcon = iconAsElement;
			}
			return (
				<div className={mainClass} onClick={clickAction}>
					{qIcon}
					{modal}
				</div>
			);
		} else {
			let infoClass = styles.info;
			if (textClass) infoClass += " " + textClass;
			let qIcon = qSvg;
			if (iconAsElement) {
				qIcon = iconAsElement;
			}
			return (
				<div className={mainClass}>
					<div className={infoClass}>{text}</div>
					{qIcon}
				</div>
			);
		}
	},
});
